import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

type Props = {};

export default function CallbackSspPage({}: Props) {
  const location = useLocation();
  const [params, setParams] = React.useState<{ [key: string]: string }>({});
  const formRef = useRef<HTMLFormElement>(null); // 폼 참조 생성

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const paramObject: { [key: string]: string } = {};

    searchParams.forEach((value, key) => {
      paramObject[key] = value;
    });

    setParams(paramObject);
  }, [location.search]);

  useEffect(() => {
    if (Object.keys(params).length > 0 && formRef.current) {
      formRef.current.submit(); // 파라미터가 설정된 후 폼 제출
    }
  }, [params]);

  return (
    <div>
      {Object.keys(params).length > 0 && (
        <div data-testid="page-param" className="hidden">
          {JSON.stringify(params)}
        </div>
      )}
      {params.url && (
        <form
          ref={formRef}
          action={params.url}
          method="POST"
          data-testid="form-ssp"
        >
          <input
            type="hidden"
            name="bizno"
            value={params.bizNo}
            data-testid="input-biz-no"
          />
          <input
            type="hidden"
            name="secretText"
            value={params.secretText}
            data-testid="input-secret-text"
          />
          <input
            type="hidden"
            name="targetUrl"
            value={params.targetUrl}
            data-testid="input-target-url"
          />
        </form>
      )}
    </div>
  );
}
